<template>
  <div>
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <view-container
      :col="$vuetify.breakpoint.mobile ? 12 : 6"
      style="padding: 2vh"
    >
      <div style="margin:2%">
        <h2 color="primary" style="color: #005591" v-text="'Mis reservas'" />
        <br />
        <h2
          color="primary"
          v-if="itemsActive.length > 0"
          style="color: #00A0E1; "
          v-text="'En curso'"
        />
        <v-card
          v-for="item in itemsActive"
          :key="item.key"
          class="mx-auto cardStyle pointer"
          color="#0055911e"
          tile
          style="margin-left: 30%;"
          @click="openCard(item)"
        >
          <info-list :data="reservationFormat(item)" :state="item.estatus" />
        </v-card>
        <h2
          color="primary"
          v-if="items.length > 0"
          style="color: #00A0E1"
          v-text="'Reservas futuras'"
        />
        <v-card
          v-for="item in items"
          :key="item.key"
          class="mx-auto cardStyle pointer"
          color="#0055911e"
          tile
          style="margin-left: 30%;"
          @click="openCard(item)"
        >
          <info-list :data="reservationFormat(item)" :state="item.estatus" />
        </v-card>
        <h2
          color="primary"
          v-if="itemsFinish.length > 0"
          style="color: #00A0E1"
          v-text="'Reservas finalizadas'"
        />
        <v-card
          v-for="item in itemsFinish"
          :key="item.key"
          class="mx-auto cardStyle"
          color="#0055911e"
          tile
          style="margin-left: 30%;"
          @click="openCard(item)"
        >
          <info-list :data="reservationFormat(item)" :state="item.estatus" />
        </v-card>
        <h2
          color="primary"
          v-if="itemsCancel.length > 0"
          style="color: #00A0E1"
          v-text="'Reservas canceladas'"
        />
        <v-card
          v-for="item in itemsCancel"
          :key="item.key"
          class="mx-auto cardStyle"
          color="#0055911e"
          tile
          style="margin-left: 30%;"
          @click="openCard(item)"
        >
          <info-list :data="reservationFormat(item)" :state="item.estatus" />
        </v-card>
      </div>
      <v-bottom-sheet v-model="sheet">
        <v-sheet class="text-center" style="padding:2%">
          <view-container style="padding:1vh">
            <h2 style="color: #005591" v-text="'Acciones'" />
            <br />
            <basic-btn
              block
              colorBtn="#005591"
              dark
              text="Compartir Reunión Linde"
              @click="share"
            />
            <br />
            <basic-btn
              block
              colorBtn="#005591"
              :dark="!avaibleCheckIn()"
              :disabled="avaibleCheckIn()"
              text="Check In"
              @click="getSurvey"
            />
            <br />
            <basic-btn
              block
              colorBtn="#005591"
              dark
              text="Ver Ubicación"
              @click="getLocation"
            />
            <br />
            <basic-btn
              block
              colorBtn="grey"
              :dark="!avaibleItems()"
              text="Cancelar reserva"
              :disabled="avaibleItems()"
              @click="deleteModal = !deleteModal"
            />
            <br />
          </view-container>
        </v-sheet>
      </v-bottom-sheet>
      <v-dialog v-model="deleteModal" persistent max-width="600">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-spacer></v-spacer>
            <h2 class="tex-right" v-text="'Confirmar cancelación'" />
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <br />
            <h3>
              ¿Deseas eliminar todas las reuniones relacionadas o solo las de
              esta fecha?
            </h3>
            <v-divider></v-divider>
            <div class="itemsCenter">
              <basic-btn
                text="No cancelar ninguna"
                typeButton="text"
                @click="deleteModal = !deleteModal"
              />
            </div>
            <v-divider></v-divider>
            <div class="itemsCenter">
              <basic-btn
                text="Cancelar todas"
                typeButton="text"
                @click="remove(true)"
              />
            </div>
            <v-divider></v-divider>
            <div class="itemsCenter">
              <basic-btn
                text="Cancelar solo esta fecha"
                typeButton="text"
                @click="remove(false)"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </view-container>
  </div>
</template>

<script>
import { ViewContainer, BasicBtn, InfoList, BasicAlert } from "@/components";
import { services, time, alertMsg } from "@/utils";

export default {
  name: "home",
  components: {
    ViewContainer,
    BasicBtn,
    InfoList,
    BasicAlert,
  },
  data: () => ({
    cal: "",
    alertActive: false,
    alertMsg: "",
    alertType: "success",
    deleteModal: false,
    reservationInfo: [
      {
        title: "",
        info: "",
      },
    ],
    sheet: false,
    items: [],
    itemsCancel: [],
    itemsActive: [],
    itemsFinish: [],
    dataCard: undefined,
    dimension: 0,
    rules: {},
    dialogs: {},
    links: {},
  }),
  mounted() {
    this.getReservations();
  },
  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
  },
  methods: {
    getReservations() {
      this.itemsCancel = [];
      this.itemsActive = [];
      this.items = [];
      this.itemsFinish = [];
      services
        .ws("get", "reservations")
        .then((res) => {
          if (res.ok) {
            for (let i = 0; i < res.data.length; i++) {
              if (
                res.data[i].estatus == "Cancelado" ||
                res.data[i].estatus == "Cancelado Automatico"
              ) {
                this.itemsCancel.push(res.data[i]);
              }
              if (res.data[i].estatus == "En curso") {
                this.itemsActive.push(res.data[i]);
              }
              if (res.data[i].estatus == "Finalizado") {
                this.itemsFinish.push(res.data[i]);
              }
              if (
                res.data[i].estatus !== "Cancelado" &&
                res.data[i].estatus !== "Cancelado Automatico" &&
                res.data[i].estatus !== "En curso" &&
                res.data[i].estatus !== "Finalizado"
              ) {
                this.items.push(res.data[i]);
              }
            }
            this.items.reverse();
            this.itemsActive.reverse();
            this.itemsCancel.reverse();
            this.itemsFinish.reverse();
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openCard(item) {
      this.dataCard = item;
      this.sheet = !this.sheet;
    },
    getSurvey() {
      let data = {
        ubicacionID: this.dataCard.ubicacionID,
        zonaHoraria: time.timeZone(),
      };
      services
        .ws("get", "surveys", data, "params")
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.$router.push({
              path: "/client/Survey/" + this.dataCard.id,
              query: res.data,
            });
          } else {
            this.chekIn();
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = res.message;
          this.alertType = "error";
          this.chekIn();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    share() {
      let now = new Date();
      let start = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDay(),
        now.getHours(),
        0,
        0
      );
      let end = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDay(),
        now.getHours() + 1,
        0,
        0
      );

      this.$ics.addEvent(
        "es-mx",
        "Reserva: " + this.dataCard.fechaInicio,
        "Reserva de " +
          this.dataCard.ubicacion +
          "el día " +
          this.dataCard.fechaInicio,
        this.dataCard.ubicacion + ", " + this.dataCard.lugarTrabajo,
        start,
        end,
        null,
        null,
        null
      );

      this.cal = this.$ics.calendar();
      window.location.href =
        "mailto:?subject=" +
        "Te comparto mi reserva del día " +
        this.dataCard.fechaInicio;
      this.$ics.download("Reserva: " + this.dataCard.fechaInicio);
    },
    getLocation() {
      this.$router.push({
        path: "/client/MyLocation",
        query: {
          id: this.dataCard.id,
          initDate: this.dataCard.fechaInicio,
          lastDate: this.dataCard.fechaFin,
          location: this.dataCard.ubicacion,
        },
      });
    },
    chekIn() {
      let data = {
        data: { detReservacionID: this.dataCard.id },
      };
      services
        .ws("post", "checkIn", data)
        .then((res) => {
          if (res.ok) {
            this.alertActive = true;
            this.alertMsg = "Check In realizado correctamente";
            this.alertType = "success";
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
          this.sheet = false;
        });
    },
    remove(allDates) {
      let data = {
        data: { detReservacionID: this.dataCard.id, flag: allDates },
      };
      services
        .ws("delete", "reservation", data)
        .then((res) => {
          if (res.ok) {
            this.alertActive = true;
            this.alertMsg = "Reserva cancelada con exito";
            this.alertType = "success";
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .finally(() => {
          this.loading = false;
          this.deleteModal = false;
          this.sheet = false;

          this.getReservations();
        });
    },
    reservationFormat(item) {
      let reservationInfo = [
        {
          icon1: "mdi-clock-time-eight-outline",
          title:
            time.formatNormal(item.fechaInicio, ` D/MM/YYYY h:mm A`) +
            " a " +
            time.formatNormal(item.fechaFin, "h:mm A") +
            "<br>" +
            (time.diffTwoDates(item.fechaInicio, item.fechaFin, "hours") ===
            "12 Horas"
              ? "Todo el día"
              : time.diffTwoDates(item.fechaInicio, item.fechaFin, "hours")),
          info: "",
        },
        {
          icon1: "mdi-map-marker",
          icon2: "mdi-desk",
          title:
            (item.pais ? item.pais : "Desconocido") +
            "<br>" +
            (item.region ? item.region : "Desconocido"),
          info: (item.ubicacion ? item.ubicacion : "Desconocido") + "<br>",
        },
        {
          icon1: "mdi-account",
          icon2: "",
          title: item.personas ? item.personas : "Desconocido",
          info:
            "Piso: " +
            (item.piso ? item.piso : "Desconocido") +
            "<br>" +
            (item.lugarTrabajo ? item.lugarTrabajo : "Desconocido"),
        },
      ];
      return reservationInfo;
    },
    incre() {
      for (let index = 0; index < 81; index++) {
        setTimeout(() => {
          this.dimension = index;
        }, 0.9);
      }
    },
    avaibleItems() {
      if (this.dataCard) {
        if (
          this.dataCard.estatus === "Cancelado Automatico" ||
          this.dataCard.estatus === "Cancelado"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    avaibleCheckIn() {
      if (this.dataCard) {
        if (this.dataCard.checkin === false) {
          return true;
        } else if (
          this.dataCard.estatus == "Cancelado Automatico" ||
          this.dataCard.estatus == "Cancelado"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>

<style scoped>
.cardStyle {
  margin: 15px;
}
p {
  color: #005591;
}
</style>
